/**
 * @generated SignedSource<<732242ccb9f14ac3ec2b4147251ee799>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserAvatarText_user$data = {
  readonly isDeleted: boolean;
  readonly name: string;
  readonly picture: string | null;
  readonly " $fragmentType": "UserAvatarText_user";
};
export type UserAvatarText_user$key = {
  readonly " $data"?: UserAvatarText_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAvatarText_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picture",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDeleted",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "45bd2775190329ffda8b51ac4c7723bd";

export default node;
